import { render, staticRenderFns } from "./DataLoad.vue?vue&type=template&id=811a8382&scoped=true"
import script from "./DataLoad.vue?vue&type=script&lang=ts"
export * from "./DataLoad.vue?vue&type=script&lang=ts"
import style0 from "./DataLoad.vue?vue&type=style&index=0&id=811a8382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811a8382",
  null
  
)

export default component.exports